/**
 * Sprint Status API Client
 * Fetches dynamic sprint statuses from backend
 */
import axiosClient from './axiosClient';

export interface SprintStatus {
  id: string;
  name: string;
  display_name: string;
  description?: string;
  color?: string;
  order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export const sprintStatusAPI = {
  /**
   * Get all sprint statuses
   */
  getAll: async (): Promise<SprintStatus[]> => {
    const response = await axiosClient.get<SprintStatus[]>('/sprint-status');
    return response.data;
  },

  /**
   * Get sprint status by name
   */
  getByName: async (name: string): Promise<SprintStatus> => {
    const response = await axiosClient.get<SprintStatus>(`/sprint-status/${name}`);
    return response.data;
  },
};